import angular from 'angular';

import csmUIAlert from '../../ui/alert/alert';
import csmUIBusyScreen from '../../ui/busyScreen/busyScreen';
import csmUIStateSelector from '../../ui/stateSelector/stateSelector';
import csmUIValidators from '../../ui/validators/validators';

import { paceCardInputComponent } from './paceCardInput';
import './paceCardInput.css';

/**
 * @ngdoc    overview
 * @name     csm.payments.pace
 * @description
 * Pace processing interactions.
 **/

export default angular
  .module('csm.payments.pace', [
    csmUIAlert,
    csmUIBusyScreen,
    csmUIStateSelector,
    csmUIValidators
  ])
  .component('paceCardInput', paceCardInputComponent())
  .name;
